exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Lato:300);", ""]);
exports.push([module.id, "body{margin:0;padding:30px;font-family:Lato,sans-serif;font-size:16px;font-weight:300;background-color:#f3f4f5}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!./app.css
 ** module id = 2
 ** module chunks = 0
 **/